export default {
  download: {
    1: JSON.parse(localStorage.getItem('download-manage-vendor-1')) ?? {},
    2: JSON.parse(localStorage.getItem('download-manage-vendor-2')) ?? {},
    3: JSON.parse(localStorage.getItem('download-manage-vendor-3')) ?? {},
    4: JSON.parse(localStorage.getItem('download-manage-vendor-4')) ?? {},
  },
};
